/* src/pages/About5DD.js */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle, db } from '../apiClient';
import { logVisit } from '../analytics'; // <--- FIXED: One level up

// --- STYLES ---
const styles = {
  container: {
				  
    width: '100%', maxWidth: '1200px', margin: '0 auto',
					 
    backgroundColor: 'rgba(253, 250, 245, 0.95)', 
					   
					
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    fontFamily: "'Lato', sans-serif", color: '#333',
				  
  },
  header: {
    backgroundColor: '#e8e4d9', padding: '15px 30px',
						 
					
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
						 
    borderBottom: '1px solid #d3cdc1',
  },
  logoGroup: { display: 'flex', alignItems: 'center', cursor: 'pointer' },
  logoImg: { maxWidth: '40px', height: 'auto', marginRight: '10px' },
						 
					  
	
			
					 
				   
						
	
			 
  logoText: { fontFamily: "'Playfair Display', serif", fontSize: '1.5em', color: '#5a4b41', fontWeight: 700, margin: 0 },
  content: { padding: '40px 20px', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' },
					 
					
			  
	
			
						 
					  
					 
					  
	
  section: {
						 
    marginBottom: '40px', backgroundColor: '#fff', padding: '30px',
					
						
    borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
  },
  h1: { fontFamily: "'Playfair Display', serif", fontSize: '2.5em', color: '#5a4b41', textAlign: 'center', marginBottom: '10px' },
  h2: { fontFamily: "'Playfair Display', serif", fontSize: '1.8em', color: '#b08d6d', marginTop: '0', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' },
  h3: { fontSize: '1.2em', fontWeight: 'bold', color: '#5a4b41', marginTop: '20px' },
					 
						
						 
	
	   
											
					  
					 
				   
						 
								   
						  
	
	   
					  
					   
					 
					  
	
	  
  p: { marginBottom: '15px', fontSize: '1.05em' },
					   
	
		 
  list: { marginBottom: '15px', paddingLeft: '20px' },
						
	
			 
  listItem: { marginBottom: '8px' },
	
  actionArea: {
    backgroundColor: '#5a4b41', color: '#fff', padding: '40px',
				  
					
    borderRadius: '8px', marginTop: '20px', display: 'flex',
					  
					
    flexDirection: 'column', alignItems: 'center', textAlign: 'center',
						 
						
  },
  actionRow: { display: 'flex', flexWrap: 'wrap', gap: '40px', justifyContent: 'center', width: '100%', marginTop: '20px' },
  actionCol: { flex: '1', minWidth: '280px', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: '15px' },
  input: { padding: '12px', borderRadius: '4px', border: 'none', fontSize: '1em', width: '100%', boxSizing: 'border-box' },
				
							 
				  
					  
	
			  
			  
					  
					  
					
							
				
	
		  
					
						
				   
					
				  
							
	
  buttonPrimary: {
						 
    padding: '12px 24px', backgroundColor: '#b08d6d', color: '#fff', border: 'none',
    borderRadius: '30px', fontSize: '1.1em', cursor: 'pointer', fontWeight: 'bold', transition: 'background 0.2s',
				   
						 
					  
					  
					   
								  
  },
  buttonSecondary: {
						 
    padding: '12px 24px', backgroundColor: 'transparent', border: '2px solid #fff',
    color: '#fff', borderRadius: '30px', fontSize: '1.1em', cursor: 'pointer', fontWeight: 'bold',
				  
						 
					  
					  
					   
  },
  successMsg: { backgroundColor: '#d4edda', color: '#155724', padding: '15px', borderRadius: '5px', marginTop: '15px', fontWeight: 'bold' },
  footer: { textAlign: 'center', padding: '20px', color: '#777', fontSize: '0.9em', borderTop: '1px solid #d3cdc1', marginTop: 'auto' }
					 
					
						
					  
					   
	
		   
						
					
				  
					  
								   
					  
   
};

function About5DD() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    logVisit('About5DD_Page');
    window.scrollTo(0, 0);
  }, []);

					 

  const handleGoogleLogin = async () => {
    const redirectUrl = window.location.origin + '/'; 
    await signInWithGoogle();
  };

  const handleRequestAccess = async (e) => {
    e.preventDefault();
    if (!email) return;
    setIsSubmitting(true);

    try {
      await db.leads.create({ email: email, source: '5dd_request' });
      setMessage("Request received! We will notify you when your spot opens.");
      setEmail('');
    } catch (error) {
      console.error('Error requesting access:', error);
      setMessage("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.logoGroup} onClick={() => navigate('/')}>
          <img src="/assets/hhy_logo.png" alt="Logo" style={styles.logoImg} />
          <h2 style={styles.logoText}>Hash House Yoga</h2>
        </div>
        <button 
            onClick={() => navigate('/')}
            style={{background: 'transparent', border: '1px solid #5a4b41', padding: '5px 15px', borderRadius: '20px', cursor: 'pointer', color: '#5a4b41'}}
        >
            Back Home
        </button>
      </header>

      <main style={styles.content}>
		
        <h1 style={styles.h1}>Five Days Different</h1>
        <p style={{textAlign: 'center', fontSize: '1.2em', color: '#555', marginTop: '-10px', marginBottom: '40px'}}>
            A Course in How to Human
        </p>

										  
        <section style={styles.section}>
            <h2 style={styles.h2}>The "Why"</h2>
								
            <p style={styles.p}>Life is a constant state of change. You are never the same person from one day to the next. The ability to steer that change is the single most powerful skill you can possess. "Five Days Different" is Hash House Yoga’s 5-day program designed to give you that steerage.</p>
				
								
            <p style={styles.p}>This isn't a cleanse or a temporary fix. It is a self-directing course that installs a new pattern in your life. It is your guide on "how to human," modified for you, by you.</p>
				
								
            <p style={styles.p}>Life is full of moments where you feel stuck. You look at a part of your life—your health, your focus, your relationships, your home—and think, "This is something that I want different. I can't have this anymore."</p>
				
								
            <p style={styles.p}>This program is the tool you use to appreciate where you are and plan where you are going. In five days, you will be different. This program helps you decide what that difference looks like.</p>
				
								
																																													  
				
            <ul style={styles.list}>
                <li style={styles.listItem}>See your current patterns.</li>
                <li style={styles.listItem}>Decide which ones to change.</li>
                <li style={styles.listItem}>Install a new, beneficial practice that serves your life.</li>
            </ul>
        </section>

										  
        <section style={styles.section}>
            <h2 style={styles.h2}>The "How" — Your 5-Day Framework</h2>
								
            <p style={styles.p}>"Five Days Different" is built on a simple, powerful framework for self-awareness: <strong>What Is? What Was? What Will Be?</strong></p>
				
            
            <h3 style={styles.h3}>1. What Is? (The "5 Breaths")</h3>
								
            <p style={styles.p}>This is your starting point. The program teaches you to take five conscious breaths at any moment. You simply notice. This is your data.</p>
				

            <h3 style={styles.h3}>2. What Was? (The Journal)</h3>
								
            <p style={styles.p}>Your journal is your logbook for patterns. In the evening, you'll journal all the things that happened. In the morning, you'll review that list and prioritize your day.</p>
				

            <h3 style={styles.h3}>3. What Will Be? (The "One Thing")</h3>
								
            <p style={styles.p}>For your first five days, you will focus on the one thing you want to do. You define your goal. We provide the tools.</p>
				
        </section>

										   
        <section style={styles.section}>
            <h2 style={styles.h2}>The "What" — Your 5-Day Experience</h2>
								
            <p style={styles.p}>This program is a unique blend of firm guidance and compassionate support. Over the 5 days, the app will guide you through:</p>
				
								
																
				
            <ul style={styles.list}>
                <li style={styles.listItem}>Scheduled HH5 sessions that install the practice.</li>
                <li style={styles.listItem}>Morning prompts focused on "gratitude for opportunity."</li>
                <li style={styles.listItem}>Evening prompts focused on "gratitude for your body and wisdom."</li>
                <li style={styles.listItem}>AI-powered journaling that listens to your goals.</li>
																					   
            </ul>
								
            <p style={styles.p}>At the end of the five days, you will have accomplished something deeply personal.</p>
				
        </section>

								   
        <div style={styles.actionArea}>
            <h2 style={{...styles.h2, color: '#fff', borderBottomColor: 'rgba(255,255,255,0.3)'}}>Ready to Begin?</h2>
							   
				 
            
            <div style={styles.actionRow}>
												
                <div style={styles.actionCol}>
                    <h3 style={{color: '#fff', marginTop: 0}}>New to 5DD?</h3>
                    <p style={{fontSize: '0.9em', color: '#ddd'}}>Join the waitlist to start your 5-day journey.</p>
																	  
						
                    <form onSubmit={handleRequestAccess} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        <input 
										 
                            type="email" placeholder="Enter your email" value={email}
										 
                            onChange={(e) => setEmail(e.target.value)} required style={styles.input}
									
												
                        />
                        <button type="submit" disabled={isSubmitting} style={styles.buttonPrimary}>
                            {isSubmitting ? 'Submitting...' : 'Request Access'}
                        </button>
                    </form>
                    {message && <div style={styles.successMsg}>{message}</div>}
                </div>

									   
                <div style={{...styles.actionCol, borderLeft: '1px solid rgba(255,255,255,0.2)', paddingLeft: '40px'}}>
                    <h3 style={{color: '#fff', marginTop: 0}}>Already have access?</h3>
                    <p style={{fontSize: '0.9em', color: '#ddd'}}>Log in with your enabled Google account.</p>
																
						
                    <button onClick={handleGoogleLogin} style={styles.buttonSecondary}>
                        <i className="fas fa-google" style={{marginRight: '8px'}}></i> Sign In
                    </button>
                </div>
            </div>
        </div>

      </main>

      <footer style={styles.footer}>
        &copy; 2026 Hash House Yoga.
      </footer>
    </div>
  );
}

export default About5DD;